export default __webpack_public_path__ + "static/media/1901.00915074.png";